<template>
  <div class="po-analysis-chart" ref="chartRef"></div>
</template>

<script>
import * as echarts from 'echarts';
import { getPoAnalysis } from '@/api/po_board';

export default {
  name: 'POAnalysisChart',
  props: {
    chartData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      chart: null,
      months: [
        '1月',
        '2月',
        '3月',
        '4月',
        '5月',
        '6月',
        '7月',
        '8月',
        '9月',
        '10月',
        '11月',
        '12月',
      ],
      localChartData: {},
    };
  },
  async mounted() {
    await this.fetchData();
    this.initChart();
  },
  methods: {
    async fetchData() {
      try {
        const res = await getPoAnalysis();
        if (res.data) {
          this.localChartData = res.data.data;
        }
      } catch (error) {
        console.error('获取PO单分析数据失败:', error);
      }
    },
    initChart() {
      this.chart = echarts.init(this.$refs.chartRef);
      this.updateChart();
    },
    updateChart() {
      const series = [];
      const data = this.chartData.data || this.localChartData;
      const categories = Object.keys(data);

      // 生成柱状图系列
      categories.forEach((category) => {
        series.push({
          name: category,
          type: 'bar',
          data: data[category],
          barGap: '0%',
          emphasis: {
            focus: 'series',
          },
        });
      });

      // 添加总量折线图
      const totalData = this.months.map((_, monthIndex) => {
        return categories.reduce((sum, category) => {
          return sum + data[category][monthIndex];
        }, 0);
      });

      series.push({
        name: '总量',
        type: 'line',
        data: totalData,
        smooth: false,
        symbol: 'circle',
        symbolSize: 8,
        lineStyle: {
          width: 2,
        },
        itemStyle: {
          borderWidth: 2,
        },
      });

      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999',
            },
          },
        },
        legend: {
          data: [...categories, '总量'],
          bottom: 0,
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            data: this.months,
            axisPointer: {
              type: 'shadow',
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            name: '数量',
            axisLabel: {
              formatter: '{value}',
            },
          },
        ],
        series: series,
      };

      this.chart.setOption(option);
    },
  },
  watch: {
    chartData: {
      deep: true,
      handler() {
        this.updateChart();
      },
    },
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
      this.chart = null;
    }
  },
};
</script>

<style scoped>
.po-analysis-chart {
  width: 100%;
  height: 100%;
}
</style>